import { ofType, combineEpics } from 'redux-observable';
import { mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { startWithEndWith, NO_OP } from 'middleware/utils';
import {
  toggleAccountLoading,
  accountLoginSuccess,
  accountLoginError,
  accountGetListSuccess,
  accountRefreshAccount,
} from 'store/account/actions';
import { clearData } from 'store/actions';
import {
  ACCOUNT_LOGIN,
  ACCOUNT_GET_ALL,
  ACCOUNT_UPDATE,
  ACCOUNT_CREATE,
} from './actions';

const accountLoginEpic = (action$, state$, { accountRequest }) => action$.pipe(
  ofType(ACCOUNT_LOGIN),
  mergeMap((params) => {
    const { payload } = params;
    const { username, password } = payload;
    return accountRequest.login$(username, password).pipe(
      mergeMap((response) => {
        window.localStorage.setItem('access_token', response.data.token);
        return of(accountLoginSuccess(response));
      }),
      catchError(error => of(accountLoginError(error))),
      startWithEndWith(toggleAccountLoading(true), toggleAccountLoading(false)),
    );
  }),
  catchError(() => of(NO_OP)),
);

const getListAccountEpic = (action$, state$, { accountRequest }) => action$.pipe(
  ofType(ACCOUNT_GET_ALL),
  mergeMap(() => accountRequest.getListAccount$().pipe(
    mergeMap(response => of(accountGetListSuccess(response))),
    catchError(() => of(clearData())),
    startWithEndWith(toggleAccountLoading(true), toggleAccountLoading(false)),
  )),
  catchError(() => of(NO_OP)),
);

const accountCreateEpic = (action$, state$, { accountRequest }) => action$.pipe(
  ofType(ACCOUNT_CREATE),
  mergeMap((params) => {
    const { payload } = params;
    const { username, password, displayName } = payload;
    return accountRequest.createAccount$(username, password, displayName).pipe(
      mergeMap(response => of(accountRefreshAccount(response))),
      catchError(() => of(NO_OP)),
      startWithEndWith(toggleAccountLoading(true), toggleAccountLoading(false)),
    );
  }),
  catchError(() => of(NO_OP)),
);

const accountUpdateEpic = (action$, state$, { accountRequest }) => action$.pipe(
  ofType(ACCOUNT_UPDATE),
  mergeMap((params) => {
    const { payload } = params;
    const { id, data } = payload;
    return accountRequest.update$(id, data).pipe(
      mergeMap(response => of(accountRefreshAccount(response))),
      catchError(() => of(NO_OP)),
      startWithEndWith(toggleAccountLoading(true), toggleAccountLoading(false)),
    );
  }),
  catchError(() => of(NO_OP)),
);

export default combineEpics(
  accountLoginEpic,
  getListAccountEpic,
  accountUpdateEpic,
  accountCreateEpic,
);
